export default {
  show: true,
  title:
    "🚀 New in Apphud: Design + Launch Custom Paywalls in Minutes with Paywall Screens Builder Kit!",
  link: {
    href: "https://apphud.com/blog/apphud-product-updates-july-2025",
    title: "Let’s see",
  },
};
